import { useQuery } from '@tanstack/react-query';

import { accountUserDetailKey } from '../common/queryKeys';
import AccountUserApi from '../../../../../lib/api/account/user/AccountUserApi';
import { setRequestForm } from '../../../../../lib/common';
import {
  ACCOUNT_USER_DETAIL_LIKE_BRAND_LIST_FILER_OPTION_MODEL,
  ACCOUNT_USER_DETAIL_LIKE_BRAND_LIST_SORT_OPTION_MODEL,
  ACCOUNT_USER_LIKE_BRAND_DETAIL_MODEL,
  ACCOUNT_USER_LIKE_BRAND_LIST_MODEL,
  ACCOUNT_USER_LIKE_BRAND_LOG_LIST_MODEL,
} from './models';

export const useAccountUserLikeBrandDetailQuery = ({ userId, options }) => {
  return useQuery(
    [...accountUserDetailKey, 'likeBrand', 'detail', userId],
    async () => {
      const result = await AccountUserApi.getAccountUserLikeBrandDetail(
        setRequestForm(
          {
            userId,
            likeBrandHistory: {
              filterOption: ACCOUNT_USER_DETAIL_LIKE_BRAND_LIST_FILER_OPTION_MODEL,
              sortOption: ACCOUNT_USER_DETAIL_LIKE_BRAND_LIST_SORT_OPTION_MODEL,
            },
          },
          true,
        ),
      );

      if (result.msg) throw new Error(result.msg);
      return result;
    },
    {
      ...options,
      initialData: {
        data: {
          likeBrandSummaryData: ACCOUNT_USER_LIKE_BRAND_DETAIL_MODEL,
        },
      },
    },
  );
};

export const useAccountUserDetailLikeBrandListQuery = ({ userId, filterOption, sortOption, options }) => {
  return useQuery(
    [...accountUserDetailKey, 'likeBrand', 'list', filterOption, sortOption, userId],
    async () => {
      const result = await AccountUserApi.getAccountUserDetailLikeBrandList(
        setRequestForm({ userId, likeBrandHistory: { filterOption, sortOption } }, true),
      );

      if (result.msg) throw new Error(result.msg);
      return result;
    },
    {
      ...options,
      initialData: {
        data: {
          likeBrandHistoryList: ACCOUNT_USER_LIKE_BRAND_LIST_MODEL,
        },
      },
    },
  );
};

export const useAccountUserDetailLikeBrandLogListQuery = ({
  userId,
  pagination,
  filterOption,
  sortOption,
  options,
  actionLogType,
}) => {
  return useQuery(
    [...accountUserDetailKey, 'likeProduct', 'logList', pagination, filterOption, sortOption, actionLogType, userId],
    async () => {
      const result = await AccountUserApi.getAccountUserDetailLikeBrandLogList(
        setRequestForm(
          {
            userId,
            likeBrandLogHistory: { filterOption: { ...filterOption, actionLogType }, pagination, sortOption },
          },
          true,
        ),
      );

      if (result.msg) throw new Error(result.msg);
      return result;
    },
    {
      ...options,
      initialData: {
        data: ACCOUNT_USER_LIKE_BRAND_LOG_LIST_MODEL,
      },
    },
  );
};
